// export const URL_BACKEND_ROOT = `http://192.168.10.35:8082`; // TEST
export const URL_BACKEND_ROOT = `https://ns9.checkin.mn`; // PROD
export const URL_BACKEND_AUTH = `${URL_BACKEND_ROOT}/v1/uaa/oauth/token`;

// AUTH/
export const BASIC_USERNAME = "web";
export const BASIC_PASSWORD = "S3cR3T";

export const REFRESH_TOKEN_MAX_ITERATE = 5;

export const CMS_BASIC_USERNAME = "";
export const CMS_BASIC_PASSWORD = "";

export const ENABLE_CLIENT_TOKEN = false;

export const getUserStatus = (status?: string): string => {
    switch (status) {
        case "PENDING_VERIFICATION":
            return "warning";   // yellow
        case "ACTIVE":
            return "success";   // green
        case "BLOCKED":
            return "secondary"; // gray
        case "DELETED":
            return "danger";    // red
        default:
            return "light";     // fallback
    }
};

export const getUserType = (status?: string): string => {
    switch (status) {
        case "INDIVIDUAL":
            return "success";   // yellow
        case "COMPANY":
            return "secondary";   // green
        default:
            return "light";     // fallback
    }
};

export const getUserKycStatus = (status?: string): string => {
    switch (status) {
        case "NONE":
            return "secondary";  // gray
        case "PENDING":
            return "warning";    // yellow
        case "APPROVED":
            return "success";    // green
        case "REJECTED":
            return "danger";     // red
        default:
            return "light";
    }
};

export const getUserKycLevel = (status?: string): string => {
    switch (status) {
        case "NONE":
            return "secondary";  // gray
        case "BASIC":
            return "info";       // blue
        case "ADVANCED":
            return "primary";    // darker blue
        default:
            return "light";
    }
};

export const getCategoryStatus = (status?: string): string => {
    switch (status) {
        case "ACTIVE":
            return "success";
        case "HIDDEN":
            return "warning"; 
        case "DISABLED":
            return "secondary"; 
        default:
            return "light";
    }
};

export const getYesNo = (status?: boolean) => {
    switch (status) {
        case true:
            return "success";
        case false:
            return "danger";
    }
};

export const getAttributeDataType = (type?: string): string => {
    switch (type) {
        case "TEXT":
            return "primary";
        case "NUMBER":
            return "info";
        case "BOOLEAN":
            return "warning";
        case "CHOICE":
            return "success";
        default:
            return "secondary";
    }
};

export const getAttributeUiType = (type?: string): string => {
    switch (type) {
        case "TEXT":
            return "primary";
        case "DROPDOWN":
            return "info";
        case "COLOR":
            return "warning";
        case "IMAGE":
            return "success";
        default:
            return "secondary";
    }
};

export const getAttributeStatus = (status?: string): string => {
    switch (status) {
        case "ACTIVE":
            return "success";
        case "HIDDEN":
            return "warning"; 
        case "DISABLED":
            return "secondary"; 
        default:
            return "light";
    }
};

export const getBrandStatus = (status?: string): string => {
    switch (status) {
        case "ACTIVE":
            return "success";
        case "HIDDEN":
            return "warning"; 
        case "DISABLED":
            return "secondary"; 
        default:
            return "light";
    }
};

export const getProductMeasureSource = (source?: string): string => {
    switch (source) {
        case "MODEL_DEFAULT":
            return "secondary";
        case "USER":
            return "primary";
        case "OPERATOR":
            return "info";
        default:
            return "light";
    }
};

export const getProductStatus = (status?: string): string => {
    switch (status) {
        case "DRAFT":
            return "warning";
        case "ACTIVE":
            return "success";
        case "HIDDEN":
            return "secondary";
        case "DELETED":
            return "danger";
        case "LOCKED":
            return "dark";
        case "SOLD":
            return "primary";
        default:
            return "light";
    }
};

export const getProductCondition = (condition?: string): string => {
    switch (condition) {
        case "NEW":
            return "success";
        case "LIKE_NEW":
            return "primary";
        case "USED_GOOD":
            return "info";
        case "USED_FAIR":
            return "warning";
        case "FOR_PARTS":
            return "danger";
        default:
            return "secondary";
    }
};

export const getAuctionPermissionBadge = (permission?: string): string => {
    switch (permission) {
        case "PUBLIC":
            return "success";
        case "PRIVATE":
            return "secondary";
        default:
            return "light";
    }
};

export const getAuctionTypeBadge = (type?: string): string => {
    switch (type) {
        case "AUCTION":
            return "primary";
        case "DIRECT_BUY":
            return "info";
        default:
            return "secondary";
    }
};

export const getAuctionStatusBadge = (status?: string): string => {
    switch (status) {
        case "DRAFT":
            return "warning";
        case "ACTIVE":
            return "success";
        case "CANCELLED":
            return "danger";
        case "ENDED":
            return "secondary";
        case "SUSPENDED":
            return "dark";
        default:
            return "light";
    }
};

export const getAuctionEndedReasonBadge = (reason?: string): string => {
    switch (reason) {
        case "SOLD":
            return "success";
        case "NO_WINNER":
            return "warning";
        case "MANUAL":
            return "info";
        case "SYSTEM":
            return "secondary";
        default:
            return "light";
    }
};

export const getDeliveryStatusBadge = (status?: string): string => {
    switch (status) {
        case "CREATED":
            return "secondary";

        case "AWAITING_SHIPPING_PAYMENT":
            return "warning";

        case "AWAITING_EXTRA_SHIPPING_PAYMENT":
            return "warning";

        case "READY_FOR_PICKUP":
            return "info";

        case "ASSIGNED_TO_DRIVER":
            return "primary";

        case "PICKED_UP":
            return "primary";

        case "SHIPPED":
            return "primary";

        case "DELIVERED":
            return "success";

        case "DELIVERY_CONFIRMED":
            return "success";

        case "FAILED":
            return "danger";

        case "CANCELLED":
            return "secondary";

        default:
            return "light";
    }
};

export const getDeliveryPaymentStatusBadge = (status?: string): string => {
    switch (status) {
        case "PAID":
            return "success";
        case "UNPAID":
            return "danger";
        default:
            return "secondary";
    }
};

export const getBankTxnStatusBadge = (status?: string): string => {
    switch (status) {
        case "NEW":
            return "info";

        case "MATCHED":
            return "success";

        case "UNMATCHED":
            return "danger";

        case "APPLIED":
            return "primary";

        case "IGNORED":
            return "secondary";

        default:
            return "light";
    }
};